import { render, staticRenderFns } from "./GalleryBlock.vue?vue&type=template&id=00eb6c90&scoped=true"
import script from "./GalleryBlock.vue?vue&type=script&lang=js"
export * from "./GalleryBlock.vue?vue&type=script&lang=js"
import style0 from "./GalleryBlock.vue?vue&type=style&index=0&id=00eb6c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eb6c90",
  null
  
)

export default component.exports